import { IRootState } from "../../../redux/rootReducer";

export const teamMapState = (state: IRootState) => ({team: state.team});